import { SubscriptionAddOnEnums } from '@weave/schema-gen-ts/dist/schemas/subscription-manager-service/v1/subscription_manager_service.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';

export const SubscriptionAddOnFeatureEnumMap: Partial<
  Record<SubscriptionAddOnEnums, Feature>
> = {
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_CALL_INTELLIGENCE]:
    Feature.CALL_INTELLIGENCE,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_DIGITAL_FORMS]: Feature.FORMS,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_ENHANCED_INSURANCE_VERIFICATION]:
    Feature.ENHANCED_INSURANCE_VERIFICATION,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_WEAVE_VERIFY]: Feature.WEAVE_VERIFY,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_TEXT_CONNECT]: Feature.TEXT_CONNECT,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_PRACTICE_ANALYTICS]:
    Feature.PRACTICE_ANALYTICS,
  [SubscriptionAddOnEnums.SUBSCRIPTION_ADDON_ONLINE_SCHEDULING]:
    Feature.ONLINE_SCHEDULING,
};
